import { Link } from "react-router-dom";
import { Home, Wrench, Phone } from "lucide-react";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div data-testid="page-404">
      <Seo path="/404" title="Seite nicht gefunden | Rümpeltaxi" noindex />
      <section className="flex min-h-[85vh] items-center bg-brand-black grain">
        <div className="container-page relative z-10 py-24">
          <span className="font-heading text-8xl font-extrabold text-yellow md:text-9xl">404</span>
          <h1 className="mt-4 max-w-2xl font-heading text-3xl font-extrabold tracking-tight text-white md:text-5xl">
            Diese Seite wurde leider nicht gefunden.
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-light-gray/70 md:text-lg">
            Vielleicht wurde sie verschoben oder die Adresse ist nicht korrekt. Über die Startseite
            oder unsere Leistungsübersicht gelangen Sie schnell zurück.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 rounded-sm bg-yellow px-6 py-3.5 font-heading font-bold text-brand-black transition-colors hover:bg-yellow-dark"
              data-testid="404-home"
            >
              <Home className="h-4 w-4" /> Zur Startseite
            </Link>
            <Link
              to="/leistungen"
              className="inline-flex items-center justify-center gap-2 rounded-sm border border-dark-gray bg-anthracite px-6 py-3.5 font-heading font-bold text-white transition-colors hover:bg-dark-gray"
              data-testid="404-services"
            >
              <Wrench className="h-4 w-4" /> Leistungen ansehen
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 rounded-sm border border-dark-gray bg-anthracite px-6 py-3.5 font-heading font-bold text-white transition-colors hover:bg-dark-gray"
              data-testid="404-contact"
            >
              <Phone className="h-4 w-4" /> Rümpeltaxi kontaktieren
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
